const FENCED_CODE_RE = /(```[\s\S]*?```|~~~[\s\S]*?~~~)/g;
const INLINE_CODE_RE = /(`+)([\s\S]*?)\1/g;

const LATEX_COMMAND_REPLACEMENTS: Array<[RegExp, string]> = [
  [/^geq?\b/g, '≥'],
  [/^leq?\b/g, '≤'],
  [/^gt\b/g, '&gt;'],
  [/^lt\b/g, '&lt;'],
  [/\\{1,2}geq?\b/g, '≥'],
  [/\\{1,2}leq?\b/g, '≤'],
  [/\\{1,2}(?:neq|ne)\b/g, '≠'],
  [/\\{1,2}approx\b/g, '≈'],
  [/\\{1,2}gt\b/g, '&gt;'],
  [/\\{1,2}lt\b/g, '&lt;'],
  [/\\{1,2}times\b/g, '×'],
  [/\\{1,2}cdot\b/g, '·'],
  [/\\{1,2}pm\b/g, '±'],
  [/\\{1,2}(?:to|rightarrow)\b/g, '→'],
  [/\\{1,2}%/g, '%'],
  [/\\{1,2}(?:left|right)\b/g, ''],
];

const MATH_SIGNAL_RE =
  /^\s*(?:geq?|leq?|gt|lt)\b|\\{1,2}(?:geq?|leq?|neq|ne|approx|gt|lt|times|cdot|pm|to|rightarrow|left|right|%)\b|[≤≥≠≈×±]|[<>]=?/;

function renderInlineMathExpression(expression: string): string | null {
  if (!MATH_SIGNAL_RE.test(expression)) return null;

  let rendered = expression.trim();
  for (const [pattern, replacement] of LATEX_COMMAND_REPLACEMENTS) {
    rendered = rendered.replace(pattern, replacement);
  }
  rendered = rendered
    .replace(/[{}]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  return rendered === expression.trim() ? null : rendered;
}

function normalizeInlineMathInText(text: string): string {
  let output = '';
  let index = 0;

  while (index < text.length) {
    const start = text.indexOf('$', index);
    if (start === -1) {
      output += text.slice(index);
      break;
    }

    output += text.slice(index, start);

    if (text[start - 1] === '\\') {
      output += '$';
      index = start + 1;
      continue;
    }

    let end = start + 1;
    while (end < text.length && text[end] !== '$' && text[end] !== '\n') {
      end += 1;
    }

    if (end >= text.length || text[end] !== '$') {
      // 未配对的 $（例如行尾前的货币金额），按普通字符输出并继续扫描，
      // 否则会丢弃后续所有行内公式
      output += '$';
      index = start + 1;
      continue;
    }

    const expression = text.slice(start + 1, end);
    const rendered = renderInlineMathExpression(expression);
    if (rendered) {
      output += rendered;
      index = end + 1;
    } else {
      output += '$';
      index = start + 1;
    }
  }

  return output;
}

function normalizeOutsideInlineCode(text: string): string {
  let output = '';
  let lastIndex = 0;
  INLINE_CODE_RE.lastIndex = 0;

  for (let match = INLINE_CODE_RE.exec(text); match; match = INLINE_CODE_RE.exec(text)) {
    output += normalizeInlineMathInText(text.slice(lastIndex, match.index));
    output += match[0];
    lastIndex = match.index + match[0].length;
  }

  output += normalizeInlineMathInText(text.slice(lastIndex));
  return output;
}

export function normalizeInlineMathForMarkdown(markdown: string): string {
  if (!markdown.includes('$')) return markdown;

  return markdown
    .split(FENCED_CODE_RE)
    .map((segment, index) => {
      if (index % 2 === 1) return segment;
      return normalizeOutsideInlineCode(segment);
    })
    .join('');
}
